import React, {useEffect, useState} from 'react';
import './ChooseCorts.css';
import CortsChoice from "../../Components/CortsChoice/CortsChoice";
import Calendar from "../../Components/Calendar/Calendar";
import Svg from "../../Components/SvgClock/Svg";
import axios from "axios";
import {Navigate, useNavigate} from "react-router-dom";
import loadingGif from "./loading.gif";
import Menu from "../../Components/Menu/Menu";
import ConnectionError from "../ConnectionError/ConnectionError";

const ChooseCorts = () => {

    const [cort, setCort] = new useState(0);
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [day, setDay] = new useState(null);
    const [pageMoved, setPageMoved] = useState(0);
    const [time, setTime] = new useState(null);
    const [gotTimes, setGotTimes] = new useState(null);
    const [refreshCalendar, setRefreshCalendar] = new useState(false);
    const [auth, setAuth] = useState(null);

    // const [daysTook, setDaysTook] = new useState([]);

    const movePage = (num) => {
        setPageMoved(num);
    }

    const movePageBack = () => {
        setPageMoved(0);
        setDay(null);
        let allDays = document.getElementsByClassName('ts');
        for (let d of allDays) {
            if (d.classList.contains('selected_day_meeting')) {
                d.classList.remove('selected_day_meeting');
            }
        }
        function resetCort() {
            setCort(0);
        }
        setTimeout(resetCort, 600);
    }

    const movePageBackCalendar = () => {
        setPageMoved(1);
        setDay(null);
        setTime(null);
        setGotTimes(null);
        setRefreshCalendar(true);
        let allDays = document.getElementsByClassName('ts');
        for (let d of allDays) {
            if (d.classList.contains('selected_day_meeting')) {
                d.classList.remove('selected_day_meeting');
            }
        }
        function resetSvg() {
            for (let i = 6; i <= 23; i++) {
                if (!(document.getElementById('r_' + (i).toString()).classList.contains('on-init-not-display'))) {
                    document.getElementById('r_' + (i).toString()).classList.add('on-init-not-display');
                    document.getElementById('r_' + (i).toString() + 'c').classList.add('on-init-not-display');
                }
                if (document.getElementById('a_' + (i).toString()).classList.contains('on-init-not-display')) {
                    document.getElementById('a_' + (i).toString()).classList.remove('on-init-not-display');
                    document.getElementById('a_' + (i).toString() + 'c').classList.remove('on-init-not-display');
                }
            }
        }
        setTimeout(resetSvg, 1000);
    }

    const navigate = useNavigate();

    useEffect(() => {

        let getCorts;
        // axios.get(`${process.env.REACT_APP_HOST || ''}/api/get_courts/`, {headers: { 'Content-Type': 'application/json' }, withCredentials: true})
        axios.get(`/api/get_courts/`, {headers: { 'Content-Type': 'application/json' }, withCredentials: true})
            .then(res => {
                getCorts = res.data.detail;
                setAuth(true);
                console.log(res.data.detail);
                if (cort !== 0) {
                    movePage(1);
                }
                if (day !== null) {
                    setRefreshCalendar(false);
                    let cort_id;
                    if (cort===1){
                        // cort_id = '9d0564d1-2468-408a-a59d-f54317b0f5b7';
                        cort_id = getCorts[0].id_cort;
                    } else if (cort===2) {
                        // cort_id = '1405d276-27a2-4c53-8f44-6a52aae500c9';
                        cort_id = getCorts[1].id_cort;
                    }
                    let year = day.getFullYear();
                    let month = (day.getMonth() + 1).toString().padStart(2, '0');  // Месяц от 0 до 11, поэтому добавляем 1
                    let dayz = day.getDate().toString().padStart(2, '0');
                    let formattedDate = `${year}-${month}-${dayz}`;
                    // axios.get(`${process.env.REACT_APP_HOST || ''}/api/get-available-times/`, {params:  {court_id: cort_id, date: formattedDate} }, {headers: { 'Content-Type': 'application/json' }, withCredentials: true})
                    axios.get(`/api/get-available-times/`, {params:  {court_id: cort_id, date: formattedDate} }, {headers: { 'Content-Type': 'application/json' }, withCredentials: true})
                        .then(res => {
                            console.log(res.status);
                            if (res.data !== null) {
                                setGotTimes(res.data);
                            }
                        })
                        .catch(e => {
                            console.log(e);
                        })
                    movePage(2);
                }
                if (time !== null) {
                    let cort_id;
                    if (cort===1){
                        // cort_id = '9d0564d1-2468-408a-a59d-f54317b0f5b7';
                        cort_id = getCorts[0].id_cort;
                    } else if (cort===2) {
                        // cort_id = '1405d276-27a2-4c53-8f44-6a52aae500c9';
                        cort_id = getCorts[1].id_cort;
                    }
                    // axios.post(`${process.env.REACT_APP_HOST || ''}/api/order-court/${cort_id}/`, {id_cort: cort_id, time_start: new Date(day.setHours(parseInt(time))).toISOString(), players_count: 2}, {headers: {
                    axios.post(`/api/order-court/${cort_id}/`, {id_cort: cort_id, time_start: new Date(day.setHours(parseInt(time))).toISOString(), players_count: 2}, {headers: {
                                'Content-Type': 'application/json',
                                'Access-Control-Allow-Origin': '*',
                                'X-CSRFToken': getCookie('csrftoken'),
                                'Access-Control-Allow-Headers': 'X-CSRFToken'},
                                withCredentials: true})
                        .then(res => {
                            console.log(res.status);
                            if (res.status===200) {
                                document.getElementById('r_' + (time).toString()).classList.remove('on-init-not-display');
                                document.getElementById('r_' + (time).toString() + 'c').classList.remove('on-init-not-display');
                            }
                        })
                        .catch(e => {
                            console.log(e);
                            if (e.status === 418) {
                                alert(e.response.data.detail);
                            }
                            if (e.status === 425) {
                                alert('После отмены бронирования должно пройти 15 минут, пожалуйста подождите');
                            }

                            setTime(null);
                        })
                }
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
                else {
                    setAuth(false);
                    // setAuth(true); // delete after
                    // movePage(2); // delete after
                }
            })

        console.log('cortttt: ', getCorts);

    }, [day, cort, time, navigate, setAuth, setGotTimes]);

    if (auth === null) {
        return (<div className={'loading-block-auth'}><img src={loadingGif} alt={'Loading...'}
                                                           className={'loading-gif-auth'}/></div>);
    }

    // if (auth === false) {
    //     return (<div className={'access-error'}>Неполадки с доступом, попробуйте зайти позже.</div>);
    // }

    if (auth === false) {
        return (<ConnectionError />);
    }

    const handlePrevMonth = () => {
        if (currentMonth === 0) {
            setCurrentMonth(11);
            setCurrentYear(currentYear - 1);
        } else {
            setCurrentMonth(currentMonth - 1);
        }
        setDay(null);
    };

    const handleNextMonth = () => {
        if (currentMonth === 11) {
            setCurrentMonth(0);
            setCurrentYear(currentYear + 1);
        } else {
            setCurrentMonth(currentMonth + 1);
        }
        setDay(null);
    };

    const getMonthName = (monthIndex) => {
        const months = [
            'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
            'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
        ];
        return months[monthIndex];
    };


    return (
        <div className={'desktop-corts-page'}>
            <Menu />
            <div className={`desktop-corts-page-container ${pageMoved===1 ? 'page-moved-1' : ''} ${pageMoved===2 ? 'page-moved-2' : ''}`}>
                <div className={'desktop-corts-page-corts'}>
                    {/*<p className={'desktop-choose-cort-description-1'}>Выберите корт</p>*/}
                    <CortsChoice setCort={setCort} cort={cort} />
                    {/*<p className={'desktop-choose-cort-description-1'}>Выберите корт</p>*/}
                </div>
                {/*<div className={`desktop-corts-page-calendar ${cort===0 ? 'disabled-calendar-opacity' : ''}`}>*/}
                <div className={'desktop-corts-page-calendar'}>
                    <Calendar setDay={setDay} currentMonth={currentMonth} currentYear={currentYear} onPrevMonth={handlePrevMonth} onNextMonth={handleNextMonth} cort={cort} refreshCalendar={refreshCalendar} />
                    <div className={day!==null ? 'disable-calendar' : ''}></div>
                    {/*<p className={'desktop-choose-cort-description-2'}>{`Выберите дату для `}<span className={'desktop-choose-cort-description-3-date-underline'}>{`корта №${cort}`}</span></p>*/}
                    <button className={pageMoved===1 ? 'back-to-cort-selection' : 'back-to-cort-selection-not-displayed'} onClick={() => movePageBack()}>{'< назад к выбору корта'}</button>
                </div>
                <div className={'desktop-corts-page-clock'}>
                    <Svg setTime={setTime} gotTimes={gotTimes} day={day} currentMonth={currentMonth} cort={cort} />
                    {/*<p className={'desktop-choose-cort-description-3'}>{`Выберите время`}</p>*/}
                    <button className={pageMoved===2 ? 'back-to-cort-selection-1' : 'back-to-cort-selection-not-displayed'} onClick={() => movePageBackCalendar()}>{'< назад к выбору дня'}</button>
                </div>
            </div>
        </div>
    );
};

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export default ChooseCorts;